import { getMailListApi } from '@/api/mail'
import type { MailListItem } from '@/api/mail/type'
import { defineStore } from 'pinia'
import { normalizeHomeModuleSetting, type HomeModuleSettingType } from '@/types/home-module'

export const useCommonStore = defineStore('common', {
  state: () => {
    return {
      isDarkMode: true,
      loading: false,
      path: 'Start',
      isSocketInit: false,
      isSocketReconnect: false,
      mailList: [] as MailListItem[],
      canCheckIn: false,
      celebrationPoint: 0,
      homeModuleSetting: normalizeHomeModuleSetting() as HomeModuleSettingType,
      homeModuleSettingLoaded: false,
    }
  },
  actions: {
    async getMailList() {
      const mailList = await getMailListApi({ page: 1, pageSize: 51 })
      this.mailList = mailList.records
    },
  },
})
